import { Box, Text } from "@chakra-ui/react";
import config from "config/config";

export const TestEnvironmentBanner = () =>
  config.buildEnv === "staging" ? (
    <Box
      pos="fixed"
      top={0}
      zIndex={10}
      transform="rotate(-90deg) translate(-100%, 0)"
      transformOrigin="left top"
      w="100vh"
      bgGradient="linear-gradient(90deg, rgba(63,94,251,1) 0%, rgba(252,70,107,1) 100%)"
      color="white"
      textAlign="center"
      py={{ base: "unset", xl: 3 }}
      fontSize={{ base: "8px", xl: "xs" }}
    >
      🚧&nbsp; Caution: This is the
      <Text px="1" fontWeight="bold" color="inherit" fontSize="inherit" display="inline-block">
        staging
      </Text>
      environment of our website. Content, features, and functionalities are under active development and testing.
    </Box>
  ) : null;
